// removed by extract-text-webpack-plugin
module.exports = {"logoImage":"Logo-m__logoImage___2lfyk","logo":"Logo-m__logo___3hX7z"};


//////////////////
// WEBPACK FOOTER
// ./components/logo/Logo.m.sass
// module id = SWdq
// module chunks = 0